var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9318 1.5C14.2898 1.5 15.8737 3.11475 15.8737 5.51775V12.4147C15.8737 14.8387 14.3385 16.4152 11.9625 16.4302L6.19275 16.4325C3.83475 16.4325 2.25 14.8177 2.25 12.4147V5.51775C2.25 3.093 3.78525 1.51725 6.16125 1.503L11.931 1.5H11.9318ZM11.9318 2.625L6.165 2.628C4.419 2.6385 3.375 3.7185 3.375 5.51775V12.4147C3.375 14.226 4.42875 15.3075 6.192 15.3075L11.9588 15.3052C13.7048 15.2947 14.7487 14.2132 14.7487 12.4147V5.51775C14.7487 3.7065 13.6958 2.625 11.9318 2.625ZM11.7871 11.6053C12.0976 11.6053 12.3496 11.8573 12.3496 12.1678C12.3496 12.4783 12.0976 12.7303 11.7871 12.7303H6.37208C6.06157 12.7303 5.80958 12.4783 5.80958 12.1678C5.80958 11.8573 6.06157 11.6053 6.37208 11.6053H11.7871ZM11.7871 8.4654C12.0976 8.4654 12.3496 8.7174 12.3496 9.0279C12.3496 9.3384 12.0976 9.5904 11.7871 9.5904H6.37208C6.06157 9.5904 5.80958 9.3384 5.80958 9.0279C5.80958 8.7174 6.06157 8.4654 6.37208 8.4654H11.7871ZM8.4381 5.3328C8.7486 5.3328 9.0006 5.5848 9.0006 5.8953C9.0006 6.2058 8.7486 6.4578 8.4381 6.4578H6.37185C6.06135 6.4578 5.80935 6.2058 5.80935 5.8953C5.80935 5.5848 6.06135 5.3328 6.37185 5.3328H8.4381Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentWhite);
export default __webpack_public_path__ + "static/media/document-white.48d1e7917a949cbf350f80c73f6ec0f9.svg";
export { ForwardRef as ReactComponent };